<template>
	<div class="pdp-raddar">
		<h2 class="header">
			<span class="pdpTitle">{{ lang.pdpTitle }}</span>
		<button v-if="!isXRayEnabled" :aria-label="lang.pdpClose" class="close-btn" tabindex="0" @click="close"
		        @keydown.esc="close">
			<img alt="Close" src="/images/icon-close-white.svg"/>
		</button>
		</h2>
		<div ref="toastContent" class="content">
			<div :class="`content-container ${flyerOrientation}`">
				<div class="handle-border">
					<div class="pdpContainer">
						<div class="productImageContainer">
							<image-magnifier
								:image-src="productImage"
								:alt-text="productName || 'Product image'"
							/>
						</div>
						<div v-if="savings" class="savings">
							<span>
								{{ savingsPrefix }}
								{{ savings }}
								{{ savingsSuffix }}</span>
						</div>

						<div class="price" tabindex="0">
							<h2>
								<span v-if="salePrice">
									<span v-if="priceQty" class="price-qty">{{ priceQty }} /</span>
									<span class="price-prefix">{{ pricePrefix }}</span>
									<span class="price-price">{{ salePrice }}</span>
									<span class="price-unit">{{ promoUnit }}</span>
									<span v-if="taxSuffix">{{taxSuffix}}</span>
								</span>
								<p v-if="alternatePrice" class="alternatePrice">{{ alternatePrice }}</p>
								<h4 v-if="regularPrice && regularPrice !== salePrice" class="regularPrice">
									<span class="label">{{ lang.pdpRegularPrice }} :</span>
									<span>{{ regularPrice }}</span>
							    </h4>
							</h2>
						</div>
            <div v-if="showTierEachPrice" class="daysOnly">
              {{ tierEachPrice }}
            </div>
						<div v-if="showProductName" class="detail">
							<div class="detail-header">
								<h2 tabindex="0"> {{ productName }} </h2>
							</div>
						</div>
						<div v-if="description" class="detail">
							<div>
								<span>{{ lang.pdpDetails }}</span>
								<p class="detail-content" tabindex="0" v-html="htmlDescription" />
							</div>
						</div>
						<div class="detail">
							<span v-if="sku" class="product-sku">#{{ sku }}</span>
						</div>

						<div class="validity">
							<span><strong>{{ lang.pdpValidFrom }}</strong></span>
							<div v-html="htmlValidity"></div>
						</div>
					</div>
					<div v-if="!isXRayEnabled" class="button-container">
						<div class="button-container">
							<shopping-list-button :product="product"/>
						</div>
						<div class="button-container">
							<div v-if="config.allowShare" v-tooltip="{content: `Share`,  placement:'bottom'}" :href="productURL" class="pdp-btn round" target="_blank" @click=handleShareDeal(product)>
								<svg class="icon" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<title>9D711932-C33A-4FC1-805D-8E2D5C4F78DA</title>
									<g id="R2---Desktop-wireframes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
										<g id="raddar_R2_PDP_1.0" transform="translate(-1357, -638)" fill="currentColor" fill-rule="nonzero">
											<g id="popup-pdp-copy" transform="translate(1166, 195)">
												<path d="M204.132987,453.285727 C203.25937,453.292133 202.436771,453.698479 201.900379,454.388586 L196.601505,451.737154 C196.669665,451.497232 196.706139,451.249411 196.709994,451.00001 C196.706139,450.75061 196.669665,450.502788 196.601505,450.262866 L201.900379,447.611434 C202.436771,448.301541 203.25937,448.707887 204.132987,448.714293 C205.709759,448.714293 206.987985,447.435105 206.987985,445.857147 C206.987985,444.279188 205.709759,443 204.132987,443 C202.556216,443 201.27799,444.279188 201.27799,445.857147 C201.281846,446.106547 201.318319,446.354368 201.38648,446.59429 L196.087605,449.245722 C195.551213,448.555615 194.728614,448.14927 193.854997,448.142864 C192.278226,448.142864 191,449.422052 191,451.00001 C191,452.577969 192.278226,453.857157 193.854997,453.857157 C194.728614,453.850751 195.551213,453.444405 196.087605,452.754298 L201.38648,455.40573 C201.070707,456.589151 201.543834,457.842343 202.562665,458.521142 C203.581496,459.199942 204.919331,459.15331 205.888501,458.405217 C206.857671,457.657124 207.242527,456.374027 206.845245,455.21546 C206.447963,454.056893 205.356942,453.280648 204.132987,453.285727 Z" id="icon-share-grey"></path>
											</g>
										</g>
									</g>
								</svg>
							</div>
							<a v-if="productURL" :href="productURL" class="pdp-btn round shop-now" target="_blank">
								{{lang.pdpRaddarShopNow}}
								<!-- <svg class="icon" version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<title>42D445B9-8057-47B2-A7AF-03D5707F36E5</title>
									<g id="R2---Desktop-wireframes" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
										<g id="raddar_R2_PDP_1.0" fill="currentColor" fill-rule="nonzero" transform="translate(-1398, -638)">
											<g id="popup-pdp-copy" transform="translate(1166, 195)">
												<path id="Icon-website"
												      d="M240,459 C244.41077,459 248,455.41077 248,451 C248,446.58923 244.408265,443 240,443 C235.586725,443 232,446.591735 232,451 C232,455.41077 235.586725,459 240,459 Z M239.371321,448.302442 L239.371321,450.368817 L236.791484,450.368817 C236.824045,449.652473 236.911709,448.958673 237.054477,448.302442 L239.371321,448.302442 L239.371321,448.302442 Z M234.539762,447.045085 C235.190983,446.148403 236.050094,445.427051 237.036944,444.94114 C236.924233,445.116468 236.819036,445.299311 236.716343,445.494678 C236.473388,445.96556 236.260488,446.486537 236.087664,447.045085 L234.539762,447.045085 Z M239.371321,444.397621 L239.371321,447.047589 L237.410144,447.047589 C237.537884,446.699436 237.678147,446.376331 237.830933,446.078272 C238.276769,445.231684 238.810269,444.64809 239.371321,444.397621 Z M236.087664,454.954915 C236.260488,455.513463 236.473388,456.03444 236.716343,456.502818 C236.819036,456.698184 236.924233,456.883532 237.036944,457.056356 C236.050094,456.572949 235.190983,455.851597 234.539762,454.954915 L236.087664,454.954915 Z M239.371321,454.954915 L239.371321,457.604884 C238.810269,457.35191 238.276769,456.768316 237.830933,455.921728 C237.678147,455.623669 237.535379,455.298059 237.410144,454.954915 L239.371321,454.954915 Z M239.371321,451.628679 L239.371321,453.692549 L237.054477,453.692549 C236.911709,453.038823 236.82154,452.347527 236.791484,451.628679 L239.371321,451.628679 Z M233.284909,450.368817 C233.350031,449.652473 233.530369,448.958673 233.81841,448.302442 L235.769568,448.302442 C235.641828,448.968691 235.561678,449.659987 235.531622,450.368817 L233.284909,450.368817 Z M233.284909,451.628679 L235.529117,451.628679 C235.559173,452.337508 235.639324,453.031309 235.769568,453.692549 L233.81841,453.692549 C233.530369,453.038823 233.352536,452.345022 233.284909,451.628679 Z M244.227927,448.302442 L246.176581,448.302442 C246.467126,448.963682 246.644959,449.654978 246.712586,450.368817 L244.468378,450.368817 C244.435817,449.659987 244.355667,448.966187 244.227927,448.302442 Z M246.712586,451.628679 C246.644959,452.345022 246.467126,453.036318 246.179086,453.695053 L244.227927,453.695053 C244.355667,453.033813 244.435817,452.340013 244.468378,451.631183 L246.712586,451.631183 L246.712586,451.628679 Z M243.91484,447.045085 C243.739512,446.486537 243.526612,445.96556 243.281152,445.494678 C243.180964,445.299311 243.073262,445.116468 242.960551,444.94114 C243.949906,445.424546 244.806512,446.145899 245.457733,447.045085 L243.91484,447.045085 Z M240.628679,447.045085 L240.628679,444.397621 C241.187226,444.64809 241.725736,445.231684 242.166562,446.078272 C242.321853,446.376331 242.462116,446.699436 242.587351,447.047589 L240.628679,447.047589 L240.628679,447.045085 Z M240.628679,450.368817 L240.628679,448.302442 L242.945523,448.302442 C243.088291,448.961177 243.17846,449.652473 243.208516,450.368817 L240.628679,450.368817 Z M245.457733,454.954915 C244.806512,455.851597 243.947401,456.572949 242.960551,457.05886 C243.073262,456.883532 243.180964,456.698184 243.281152,456.502818 C243.529117,456.03444 243.739512,455.513463 243.91484,454.954915 L245.457733,454.954915 L245.457733,454.954915 Z M240.628679,453.695053 L240.628679,451.628679 L243.208516,451.628679 C243.17846,452.347527 243.085786,453.038823 242.945523,453.695053 L240.628679,453.695053 Z M240.628679,457.602379 L240.628679,454.954915 L242.587351,454.954915 C242.462116,455.300564 242.321853,455.626174 242.166562,455.924233 C241.723231,456.768316 241.187226,457.35191 240.628679,457.602379 Z"></path>
											</g>
										</g>
									</g>
								</svg> -->
							</a>
						</div>

					</div>
					<div
						v-if="showPharmaDisclaimer"
						:style="pharmaDisclaimerStyles"
						class="pharma-disclaimer-container"
					>
						<div v-if="showBilingualDisclaimer" class="en-pharma-disclaimer-container">
							<h2>{{ lang.pharmaDisclaimer.titleEn }}</h2>
							<h3>
								affiliated to
								<span :style="{ color: config.pharmaDisclaimer.logoColor }">
									<img :src="getLogo" alt="logo" />
									{{ clientName }}
								</span>
								are proud to offer you products and advice for your health
							</h3>
							<strong>{{ lang.pharmaDisclaimer.impMsgEn }}</strong>
							<p>{{ lang.pharmaDisclaimer.message1En }} {{ clientName }} {{ lang.pharmaDisclaimer.message2En }}</p>
						</div>

						<div class="fr-pharma-disclaimer-container">
							<h2>{{ lang.pharmaDisclaimer.titleFr }}</h2>
							<h3>
								affiliés à
								<span :style="{ color: config.pharmaDisclaimer.logoColor }">
									<img :src="getLogo" alt="logo" />
									{{ clientName }}
								</span>
								vous offrent des produits et des conseils pour votre santé
							</h3>
							<strong>{{ lang.pharmaDisclaimer.imgMsgFr }}</strong>
							<p>{{ lang.pharmaDisclaimer.message1Fr }} {{ clientName }} {{ lang.pharmaDisclaimer.message2Fr }}</p>
						</div>
					</div>
					<figure v-if="showOtpDisclaimer" class="otp-disclaimer">
						<img
							src="/images/uniprix-otp-disclaimer_desktop.jpg"
							class="otp-desktop"
							alt="Avis concernant les pharmaciens-propriétaires affiliés à Uniprix"
							aria-describedby="notice-text"
						>
						<img
							src="/images/uniprix-otp-disclaimer_mobile.jpg"
							class="otp-mobile"
							alt="Avis concernant les pharmaciens-propriétaires affiliés à Uniprix"
							aria-describedby="notice-text"
						>

						<figcaption id="notice-text" class="sr-only">
							<p>
								Les pharmaciens-propriétaires affiliés à Uniprix sont les seuls
								responsables de l'exercice de la pharmacie.
							</p>

							<p>
								Pour consulter la liste des pharmaciens-propriétaires, visitez uniprix.com.
							</p>

							<p><strong>MESSAGE IMPORTANT</strong></p>

							<p>
								Tout médicament ou produit de santé naturel peut causer des effets indésirables sérieux ou des
								interactions avec d'autres médicaments. Lire attentivement les instructions, mises en garde et
								dépliants fournis par le fabricant et consulter votre pharmacien lors de l'achat de tels médicaments
								ou produits de santé naturels. Toujours tenir les médicaments et produits de santé naturels hors de la
								portée des enfants. Les pharmaciens propriétaires affiliés à Uniprix sont les seuls responsables de
								la vente de ces médicaments.
							</p>
						</figcaption>
					</figure>
				</div>

			</div>
		</div>
	</div>

</template>

<script>
import PdpProductMixin from "@/features/pdp/PdpProductMixin";
import ShoppingListButton from "@/features/pdp/buttons/ShoppingListButton.vue";
import {mapActions, mapGetters} from "vuex";
import AppConfig from "@/classes/AppConfig";

export default {
	name: "PdpRaddar",
	components: {ShoppingListButton},

	mixins: [PdpProductMixin],

	computed: {
		...mapGetters(["isXRayEnabled"]),

		showPharmaDisclaimer() {
			return !this.showOtpDisclaimer && this.isPharmaProduct && this.config?.pharmaDisclaimer?.enabled;
		},
		isPharmaProduct() {
			if (this.product?.tags === null) return false;
			return this.product?.tags?.some(tag => tag?.toLowerCase() === "pharma");
		},
		showBilingualDisclaimer() {
			return this.currentFlyer?.province === "NB" || this.currentFlyer?.province === "ON";
		},
		getLogo() {
			return `/icons/favicon/${AppConfig?.AppConf?.favicon || `${AppConfig?.AppConf?.title}.ico`}`;
		},
		clientName() {
			return `${AppConfig?.AppConf?.title}`;
		},
		pharmaDisclaimerStyles() {
			return {
				"--pharma-heading-color": this.branding?.secondaryColor || "#1990cf",
				"--pharma-body-color": "#222222"
			};
		},
		showOtpDisclaimer() {
			const isUniprix = AppConfig.AppConf?.title?.toLowerCase().includes("uniprix");
			const otcCategories = [
				'OVER THE COUNTER DRUGS',
				'HEALTH AND OVER-THE-COUNTER MEDICINES'
			];
			return isUniprix && otcCategories.includes(this.product?.mainCategoryEn);
		}
	},

	methods:{
		...mapActions('pdp', ['close'])
	}
};
</script>


<style lang="scss" scoped>

.mobile {
  display: none !important;
  flex-flow: column;
  row-gap: 2em;
  padding: 1.5em;

  .description {
	display: flex;
	flex-flow: row;
	text-align: left;
	align-items: flex-end;

	> :first-child {
	  width: calc(55px + 1em);
	}

	.mobile-content {
	  flex-basis: 100%;
	}
  }
}

.modal-wpr {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 20;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-flow: column;

  .modal {
	//background-color: var(--secondary-color);
	background-color: #fff;
	/*margin-top: 75px;*/
	border: 1px solid #bbbbbb;
	/* overflow: auto;*/
	max-height: calc(100% - 1em);
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	display: flex;
	flex-flow: column;
	max-width: calc(100% - 4em);

	.header {
	  background-color: #261342;
	  color: var(--primary-text-color);
	  display: flex;
	  justify-content: space-between;
	  padding: 10px;

	  h2 {
		font-size: 18px;
		text-transform: uppercase;
		font-weight: 400;
	  }

	  .close-btn {
		cursor: pointer;

		&:hover {
		  background: none;
		  filter: unset;
		}
	  }
	}

	.subtitle {
	  padding-top: 6px;
	  font-size: 12px;
	}

	.content {
	  padding: 8px;
	  background-color: #fff;
	  color: #545454;
	  position: relative;
	  flex: 1 0 auto;
	  // overflow: auto;
	  // margin:0px 10px 10px 10px;
	  margin: 10px 10px 17px;
	  min-height: 250px;
	  max-height: calc(100% - 4em);


	  /*.scroll-container{
		position: absolute;
		top:0px;
		bottom:0px;
		left:0px;
		right:0px;
	}*/
	  .content-container {
		text-align: left;
		//width:300px;
	  }

	  .f-half {
		display: flex;
		column-gap: 1em;

		flex-direction: column;

		>div {
		  flex-basis: 100%;
		  display: flex;
		  flex-flow: column;
		}
	  }

	  .content-container {
		// width: 350px;
	  }

	  .feature {
		background: #eee;
		margin: 12px 0;
		display: flex;
		justify-content: center;
		flex: 1;

		.description {
		  display: flex;
		  font-size: 14px;
		  padding: 15px 0;

		  .button-preview {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 0 20px;

			h4 {
			  text-transform: uppercase;
			  padding-top: 16px;
			  white-space: nowrap;
			}

			.subtitle {
			  text-align: center;
			}
		  }
		}
	  }
	}
  }
}

.pdpTitle {
  font-size: 18px;
  font-weight: bold;
  margin-top: 6px;
}

.pdpContainer {
  //margin-left: 10px;
  max-width: calc(100vw - 5em);
  border: 1px solid #D3D3D3;
  padding: 10px;

  h2 {
	font-size: 18px;
	line-height: 1.1em;

	span {
	  font-size: 24px;
	  margin-top: 6px;
	  &.price-unit {
		font-size: 0.5em;
		margin-left: 0.3em;
	  }
	  &.price-qty {
		margin-right: 0.1em;
	    &:empty {
	      display: none;
	    }
	  }
	}
  }

  .productImageContainer {
	padding: 5px 0;
	margin-bottom: 10px;
	border: 1px solid #D3D3D3;
	display: flex;
	justify-content: center;
  }

  .productImage {
	// max-height: 60%;
	// max-width: 60%;
	max-height: 200px;
	max-width: 90%;
	width: auto;
	height: auto;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
  }

  .price {
	display: flex;
	//color: #ee3124;
	color: #E95B5B;
	font-weight: 900;
  }

  span.alternatePrice {
	display: inline-block;
  }

  .alternatePrice {
	color: #000;
	font-size: 13px;
	font-weight: normal;
	// margin-left: 5px;
  }

    h4.regularPrice {

	 span {
	 	color: #545454;
       	font-size: 13px;
      	font-weight: 900;
	 }

	 .label {
		margin-right: 4px;
	 }
  }

  .savings {
	text-transform: uppercase;
	color: #000;
	font-size: 17px;
	font-weight: 900;

	span {
	  display: block;
	  margin-bottom: 7px;
	}
  }

  .detail {
	font-size: 15px;
	margin-top: 10px;
	font-weight: 900;

	.detail-header{
	  display: flex;
	  h2 {
		margin-right: 5px;
	  }
	}

	.detail-content {
	  font-size: 14px;
	  font-weight: normal;
	  margin: 5px 0 8px;

	}
	.product-sku {
	  font-size: 12px;
	}
  }

  .disclaimer-content {
	font-size: 9px;
	font-weight: normal;
	margin-top: 10px;
	font-style: italic;
  }
  .daysOnly {
    margin-top: 8px;
    font-size: 1.5em;
    font-weight: 900;
  }
}

.button-container {

	.pdp-btn {
		width: unset;
            border-radius: 4px;
            padding: 0 20px;
            display: flex;
            align-items: center;
            justify-content: center;
			font-size: 14px;
			height: 2.5em;
			font-family: 'Lato Bold', sans-serif;
	}


		a.shop-now {

			background: #7C5AE5;
			text-decoration: none;
			color: #fff;

		}

}

.pharma-disclaimer-container {
  padding: 10px 12px;
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1.5px solid lightgrey;
  display: flex;
  flex-direction: column;
  gap: 10px;
  text-align: center;
  color: var(--pharma-body-color);
  overflow-y: auto;
  max-height: 250px;

  .en-pharma-disclaimer-container,
  .fr-pharma-disclaimer-container {
	color: var(--pharma-body-color);
  }

  h2 {
	color: var(--pharma-heading-color);
	font-size: 1.5em;
	line-height: 1;
	margin: 0;
  }

  h3 {
	color: var(--pharma-heading-color);
	font-size: 1em;
	line-height: 1.3;
	margin: 0;
	padding: 6px 0;

	img {
	  width: 1.1em;
	  vertical-align: baseline;
	}
  }

  strong {
	color: var(--pharma-body-color);
	display: block;
	font-size: 0.95em;
	margin: 0;
  }

  p {
	color: var(--pharma-body-color);
	font-size: 0.9em;
	line-height: 1.25;
	margin: 0;
  }
}

.otp-disclaimer {
  margin-top: 12px;

  .otp-desktop {
	display: block;
	width: 100%;
  }

  .otp-mobile {
	display: none;
	width: 100%;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

button {
  background: transparent;
  // border: 1px solid #ccc;
  text-transform: uppercase;
  font-weight: 600;
  color: #666;
  border-radius: 4px;
  border: none;
}


/* width */
::-webkit-scrollbar {
  width: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  //background: #f1f1f1;
  display: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.btn.page {
  width: 100%;
  height: 28px;
  justify-content: flex-start;
  padding-left: 3%;
  margin-bottom: 8px;

  &+.subtitle {
	text-align: left !important;
  }
}

.page-num {
  background-color: var(--primary-color);
  color: var(--primary-text-color);
  border-radius: 4px;
  font-size: 12px;
  padding: 7px;
}

/*@media only screen and (max-width: 1024px){
    .modal-wpr .modal{
      .content {
        .f-half {
          flex-direction: column !important;
        }
        .content-container{
          width: 925px;
        }
      }
    }
  }*/

.navigation {
  .description {
	flex-basis: 50%;
	justify-content: center;
  }
}

@media only screen and (max-height: 850px) and (min-width: 1024px) {
  .modal-wpr .modal {
	.content {
	  .f-half {
		flex-direction: row !important;
	  }

	  .content-container {
		width: 330px;
	  }
	}
  }
}

@media only screen and (max-width: 700px) and (min-width: 558px) {
  .modal-wpr .modal {
	.content {
	  .content-container {
		// width: 575px;
	  }
	}
  }
}

@media only screen and (max-width: 700px) {
  .modal-wpr .modal {
	.content {
	  .content-container {

		//width: 300px;
		.productImage {
		  // max-height: 50%;
		  // max-width: 50%;
		  max-height: 180px;
		  max-width: 85px;
		}
	  }
	}
  }

  .otp-disclaimer {
	.otp-desktop {
	  display: none;
	}

	.otp-mobile {
	  display: block;
	}
  }
}

/* Vertical View Specific */
@media (min-width: 1200px) {
  .modal-wpr .modal.vertical .content .feature.navigation {
	/*.description {
		padding-top: 10px;
		padding-left: 100px;
		padding-bottom: 70px;
		position: relative;
	}*/

	/*.btn.page {
		transform: rotate(90deg);
		width: 146px;
		position: absolute;
		left: 0;
		bottom: 38%;
	}*/

	h4,
	.subtitle {
	  text-align: left;
	  width: 100%;
	}

	.subtitle+.subtitle {
	  margin-top: 1em;
	}
  }

  .content-container {
	width: 330px;
  }
}

@media (max-width: 850px) {
  /*.modal-wpr {
	top: 125px;
}*/
}

@media (min-width: 850px) and (max-width: 1023px) {
  /*.modal-wpr {
	top: 125px;
}*/
}

/* Mobile */
@media (min-width: 1024px) and (max-width: 1200px) {

  /*.modal-wpr {
	top: 65px;
}*/
  .walkthrough {
	display: none;
  }
}

@media (max-width: 1200px) {
  .mobile {
	display: flex !important;
  }

  .desktop {
	display: none !important;
  }

  .modal-wpr .modal {
	/* margin-top: 140px;
	width: 90% !important;*/
	width: 338px;

	.content {
	  .f-half {
		/*flex-direction: row !important;*/
	  }

	  .content-container {
		// width: 400px;
	  }
	}

	.header {
	  padding-bottom: 4px;

	  h2 {
		font-size: 14px;
	  }
	}
  }

  .heading {
	display: none;
  }

  .modal-wpr .modal .content .feature {
	display: block;
	background: none;
	padding: 0 6%;

	.description {
	  padding: 0;
	  margin-bottom: 20px;
	  height: 50px;
	}

	.button-preview {
	  display: block;
	  position: relative;
	  padding-left: 60px;
	  width: 100%;

	  h4 {
		padding: 0;
	  }

	  .subtitle {
		text-align: left;
	  }

	  .btn {
		position: absolute;
		top: 0;
		left: 0;
	  }
	}
  }

  .subtitle.mobile {
	text-align: center;
	margin-bottom: 20px;
  }
}
</style>


<!--<style lang="scss" scoped>
.mobile {
  display: none !important;
  flex-flow: column;
  row-gap: 2em;
  padding: 1.5em;

  .description {
	display: flex;
	flex-flow: row;
	text-align: left;
	align-items: flex-end;

	> :first-child {
	  width: calc(55px + 1em);
	}

	.mobile-content {
	  flex-basis: 100%;
	}
  }
}


.pdpTitle {
  font-size: 18px;
  font-weight: bold;
  margin-top: 6px;
}

.pdpContainer {
  //margin-left: 10px;
  max-width: calc(100vw - 5em);
  border: 1px solid #D3D3D3;
  padding: 10px;

  h2 {
	font-size: 18px;
	line-height: 1.1em;

	span {
	  font-size: 24px;
	  margin-top: 6px;

	}
  }

  .productImageContainer {
	padding: 5px 0;
	margin-bottom: 10px;
	border: 1px solid #D3D3D3;
	display: flex;
	justify-content: center;
  }

  .productImage {
	// max-height: 60%;
	// max-width: 60%;
	max-height: 200px;
	max-width: 90%;
	width: auto;
	height: auto;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
  }

  .price {
	display: flex;
	//color: #ee3124;
	color: #E95B5B;
	font-weight: 900;
  }

  span.alternatePrice {
	display: inline-block;
  }

  .alternatePrice {
	color: #000;
	font-size: 13px;
	font-weight: normal;
	margin-left: 5px;
  }

  .savings {
	text-transform: uppercase;
	color: #000;
	font-size: 17px;
	font-weight: 900;

	span {
	  display: block;
	  margin-bottom: 7px;
	}
  }

  .detail {
	font-size: 15px;
	margin-top: 10px;
	font-weight: 900;

	.detail-header {
	  display: flex;

	  h2 {
		margin-right: 5px;
	  }
	}

	.detail-content {
	  font-size: 14px;
	  font-weight: normal;
	  margin: 5px 0 8px;

	}

	.product-sku {
	  font-size: 12px;
	}
  }

  .disclaimer-content {
	font-size: 9px;
	font-weight: normal;
	margin-top: 10px;
	font-style: italic;
  }

  & .validity {
	font-size: 13px;
	margin-top: 10px;

	.date {
	  color: #E95B5B;
	  font-weight: bold;
	}

  }
}

button, a.goToWebsite {
  background: transparent;
  // border: 1px solid #ccc;
  text-transform: uppercase;
  font-weight: 600;
  color: #666;
  border-radius: 4px;
  border: none;
}

button.button {
  background: #fff;
  border: 1px solid #ccc;
  text-transform: uppercase;
  font-weight: 600;
  color: #666;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 16px;
}

button.button:hover {
  background: #eee;
  color: #000;
}

.btn {
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 4px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  width: 34px;
  color: #333;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  cursor: auto;
  pointer-events: none;
}

.addtoList-container {
  display: flex;
  margin: 15px 4px 0;

  button, a.goToWebsite {
	padding: 5px;
	min-height: 34px;
	min-width: 34px;
	transition: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background-color: #D3D3D3;
	border-radius: 50%;
	margin-right: 10px;

	img {
	  width: 1.2rem;
	  height: 1.2rem;

	}
  }

  .goToWebsite {
	margin-left: auto;
	margin-right: 0;
  }
}

.pdpAddToList {
  // display: flex;
  // flex-grow: 0.7;
  cursor: pointer;
  // width: 100%;
  // border-radius: 5px;
  // margin-top:15px;
  // margin-bottom:15px;
  // margin-right: 10px;
  // margin: 15px 0px 10px 0px;
  // background-color: var(&#45;&#45;tertiary-color);
  color: #fff;
  padding: 8px;
  justify-content: center;
  // max-width: calc(100vw - 7em);
  font-weight: normal;

  &.removeFromList {
	background-color: #EE3124;
  }
}

/* width */
::-webkit-scrollbar {
  width: 15px;
}

/* Track */
::-webkit-scrollbar-track {
  //background: #f1f1f1;
  display: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.btn.page {
  width: 100%;
  height: 28px;
  justify-content: flex-start;
  padding-left: 3%;
  margin-bottom: 8px;

  & + .subtitle {
	text-align: left !important;
  }
}

.page-num {
  background-color: var(&#45;&#45;primary-color);
  color: var(&#45;&#45;primary-text-color);
  border-radius: 4px;
  font-size: 12px;
  padding: 7px;
}

/*@media only screen and (max-width: 1024px){
    .modal-wpr .modal{
      .content {
        .f-half {
          flex-direction: column !important;
        }
        .content-container{
          width: 925px;
        }
      }
    }
  }*/

.navigation {
  .description {
	flex-basis: 50%;
	justify-content: center;
  }
}

@media only screen and (max-height: 850px) and (min-width: 1024px) {
  .modal-wpr .modal {
	.content {
	  .f-half {
		flex-direction: row !important;
	  }

	  .content-container {
		width: 300px;
	  }
	}
  }
}

@media only screen and (max-width: 700px) and (min-width: 558px) {
  .modal-wpr .modal {
	.content {
	  .content-container {
		// width: 575px;
	  }
	}
  }
}

@media only screen and (max-width: 700px) {
  .modal-wpr .modal {
	.content {
	  .content-container {

		//width: 300px;
		.productImage {
		  // max-height: 50%;
		  // max-width: 50%;
		  max-height: 180px;
		  max-width: 85px;
		}
	  }
	}
  }
}

/* Vertical View Specific */
@media (min-width: 1200px) {
  .modal-wpr .modal.vertical .content .feature.navigation {
	/*.description {
		padding-top: 10px;
		padding-left: 100px;
		padding-bottom: 70px;
		position: relative;
	}*/

	/*.btn.page {
		transform: rotate(90deg);
		width: 146px;
		position: absolute;
		left: 0;
		bottom: 38%;
	}*/

	h4,
	.subtitle {
	  text-align: left;
	  width: 100%;
	}

	.subtitle + .subtitle {
	  margin-top: 1em;
	}
  }

  .content-container {
	width: 300px;
  }
}

@media (max-width: 850px) {
  /*.modal-wpr {
	top: 125px;
}*/
}

@media (min-width: 850px) and (max-width: 1023px) {
  /*.modal-wpr {
	top: 125px;
}*/
}

/* Mobile */
@media (min-width: 1024px) and (max-width: 1200px) {

  /*.modal-wpr {
	top: 65px;
}*/
  .walkthrough {
	display: none;
  }
}

@media (max-width: 1200px) {
  .mobile {
	display: flex !important;
  }

  .desktop {
	display: none !important;
  }

  .modal-wpr .modal {
	/* margin-top: 140px;
	width: 90% !important;*/
	width: 338px;

	.content {
	  .f-half {
		/*flex-direction: row !important;*/
	  }

	  .content-container {
		// width: 400px;
	  }
	}

	.header {
	  padding-bottom: 4px;

	  h2 {
		font-size: 14px;
	  }
	}
  }

  .heading {
	display: none;
  }

  .modal-wpr .modal .content .feature {
	display: block;
	background: none;
	padding: 0 6%;

	.description {
	  padding: 0;
	  margin-bottom: 20px;
	  height: 50px;
	}

	.button-preview {
	  display: block;
	  position: relative;
	  padding-left: 60px;
	  width: 100%;

	  h4 {
		padding: 0;
	  }

	  .subtitle {
		text-align: left;
	  }

	  .btn {
		position: absolute;
		top: 0;
		left: 0;
	  }
	}
  }

  .subtitle.mobile {
	text-align: center;
	margin-bottom: 20px;
  }
}
</style>-->
